import { LIMIT_INLINE_COUNT } from '../../constants';

import { AccessTypeMap } from './types';

export const MAX_COUNT = 25;
export const GLOBAL_DATE_FORMAT = 'MM/dd/yyyy';

export const DEFAULT_PAGINATION = {
  max: LIMIT_INLINE_COUNT,
  offset: 0,
};

export const OWNERS_TYPE = {
  USER: 'user',
  USERGROUP: 'usergroup',
  MACHINE: 'machine',
};

export const LIST_VIEWER_VARIANT = {
  APPLICATIONS: 'applications',
  ACCOUNT_OWNERS: 'account-owners',
  ACCESS: 'entitlements',
  SERVICE_ACCOUNTS: 'service-accounts',
};

export const LIST_VIEWER_TITLES = {
  [LIST_VIEWER_VARIANT.APPLICATIONS]: 'Select Applications',
  [LIST_VIEWER_VARIANT.ACCOUNT_OWNERS]: 'Select Account Owners',
  [LIST_VIEWER_VARIANT.ACCESS]: 'Select Access',
  [LIST_VIEWER_VARIANT.SERVICE_ACCOUNTS]: 'Select Service Accounts',
};

export const DATE_CUSTOM_LABEL_KEY = 'Custom';

export const REQUEST_OPTION_TYPE = {
  TABLE: 'Table',
  DROPDOWN: 'DropDown',
};

export const OWNERS_RANK_OPTIONS = [
  {
    label: '1',
    value: '1',
    isChecked: false,
  },
  {
    label: '2',
    value: '2',
    isChecked: false,
  },
  {
    label: '3',
    value: '3',
    isChecked: false,
  },
  {
    label: '4',
    value: '4',
    isChecked: false,
  },
  {
    label: '5',
    value: '5',
    isChecked: false,
  },
  {
    label: 'Primary Certifier',
    value: '26',
    isChecked: false,
  },
  {
    label: 'Secondary Certifier',
    value: '27',
    isChecked: false,
  },
];

export const ACCESS_TYPE_FILTER_VALUE = 'access_type';
export const ENTITLEMENT_TYPE_FILTER_VALUE = 'ENTITLEMENT_TYPE';
export const DEFAULT_ACCESS_FILTERS = [
  {
    label: 'Access Type',
    value: ACCESS_TYPE_FILTER_VALUE,
    options: [
      {
        label: 'Entitlement',
        value: AccessTypeMap.entitlement,
        isChecked: false,
      },
      {
        label: 'Enterprise Role',
        value: AccessTypeMap.enterpriseRole,
        isChecked: false,
      },
      {
        label: 'Application Role',
        value: AccessTypeMap.applicationRole,
        isChecked: false,
      },
    ],
  },
];

export const ENTITLEMENT_TYPE_FILTER = {
  label: 'Entitlement Type',
  value: ENTITLEMENT_TYPE_FILTER_VALUE,
  options: [],
};

export const DATE_FILTER_OPTIONS = [
  {
    label: 'Next 24 hours',
    value: '[0,1]',
    isChecked: false,
  },
  {
    label: 'Next 7 days',
    value: '[0,7]',
    isChecked: false,
  },
  {
    label: 'Next 14 days',
    value: '[0,14]',
    isChecked: false,
  },
  {
    label: 'Next 30 days',
    value: '[0,30]',
    isChecked: false,
  },
];

export const MAX_ACCESS_COUNT: number | null = null;
